import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setAddinObserverLoaded ')(function updateInstalledAddins() {
    // Framework team has plans to implement a .isLoaded property for lazy imports.
    // This will allow a component to re-render when the import finishes. Until this is available,
    // we'll use our own boolean in the store. WI: 23555
    store.isAddinObserverLoaded = true;
});
//# sourceMappingURL=setAddinObserverLoaded.js.map